/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BarterParcelAcreageDto } from './barterParcelAcreageDto.model';
import { BarterParcelGeometryDto } from './barterParcelGeometryDto.model';
import { ParcelBarterEntity } from './parcelBarterEntity.model';


export interface BarterParcelDto { 
    barterId?: number;
    errorHidden?: boolean;
    invalidNotUsed?: boolean;
    invalidOutdated?: boolean;
    invalidUsed?: boolean;
    katuzeKod?: number;
    lv?: number;
    parId: number;
    parcel?: ParcelBarterEntity;
    parcelId?: number;
    parcelNoFurtherRent?: boolean;
    parcelOnOtherProposalBarter?: boolean;
    parcelOnOtherValidBarter?: boolean;
    parcelOutdated?: boolean;
    parcelOutsideLpisBlocks?: boolean;
    stgImportGeomParcelAcreages?: Array<BarterParcelAcreageDto>;
    stgImportGeomParcelGeometries?: Array<BarterParcelGeometryDto>;
}

